module.exports = __webpack_public_path__ + "static/media/mute.dbf45180.svg";